import { render } from "./PasswordReset.vue?vue&type=template&id=016bd1fd"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"
script.render = render

export default script